import { FormSection } from '@openx/components-core/lib/FormSection/FormSection.tsx';
import type { PackageFormState } from '@openx/types/package.ts';
import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { useFilteredTargetingItems } from '../../../utils/hooks/useFilteredTargetingItems.ts';
import { TargetingReadOnlyList } from './TargetingReadOnlyList.tsx';

type TargetingCriteriaProps = {
  pckg: PackageFormState;
};

export const TargetingCriteria = ({ pckg }: TargetingCriteriaProps): JSX.Element => {
  const { t } = useTranslation();
  const targeting = useFilteredTargetingItems(pckg);

  return (
    <FormSection divider title={t('Targeting Criteria')}>
      <TargetingReadOnlyList packageState={pckg} targeting={targeting} />
    </FormSection>
  );
};
